import type { ComponentType, SVGProps } from 'react';
import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react';

type Props = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  iconBg?: string;
  iconColor?: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
};

export default function CarouselEmptyState({
  icon,
  iconBg = 'bg.subtle',
  iconColor = 'brand.fg',
  title,
  description,
  actionLabel,
  onAction,
}: Props) {
  return (
    <Flex
      direction='column'
      align='center'
      justify='center'
      gap={2}
      py={6}
      px={4}
      border='1px dashed'
      borderColor='border'
      borderRadius='lg'
      bg='bg.panel'
      textAlign='center'
    >
      <Flex
        align='center'
        justify='center'
        w={9}
        h={9}
        borderRadius='full'
        bg={iconBg}
      >
        <Icon as={icon} w={4} h={4} color={iconColor} />
      </Flex>
      <Box>
        <Text fontSize='ui' fontWeight='600' color='fg.strong'>
          {title}
        </Text>
        <Text fontSize='sm' color='fg.muted' mt={1} maxW='sm' mx='auto'>
          {description}
        </Text>
      </Box>
      {actionLabel && onAction && (
        <Button
          size='xs'
          variant='secondary'
          borderRadius='full'
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </Flex>
  );
}
